import React from 'react'
import { Round } from 'components/electionOverview/components/round/round'
import { Round as RoundInterface } from 'types/Round'
import { useTransition, animated, config } from 'react-spring'
import styles from './election.m.scss'

interface ElectionProps {
  rounds: RoundInterface[]
}

/**
 * Render the rounds of the election process
 * @param props
 * @param props.rounds
 */
export function Election({ rounds }: ElectionProps) {
  // Sort array, so the last round will be on top
  rounds.sort((a, b) => {
    return b.round - a.round
  })

  const transitions = useTransition(rounds, round => round.round, {
    from: { transform: 'scaleY(0)' },
    enter: { transform: 'scaleY(1)' },
    leave: { transform: 'scaleY(0)' },
    config: config.gentle
  })

  return (
    <>
      {transitions.map(({ item, key, props }) => (
        <animated.div style={props} key={key} className={styles.animated}>
          <Round {...item} />
        </animated.div>
      ))}
    </>
  )
}
